import { ReceiptsServiceScreen } from '@krp/resource-receipts-ui'
import { StatusMessage } from '@krp/ui-kit'
import { useMyAccess } from '../platform/useMyAccess'

export function ReceiptsServiceFrame({ children }: { children: React.ReactNode }) {
  const access = useMyAccess()
  const analyticsAllowed = access.data?.api.includes('platform:cashiers:read') === true
  return <ReceiptsServiceScreen>{access.data !== undefined && !analyticsAllowed ? <StatusMessage kind="forbidden" title="Нет права смотреть кассиров" text="Коды и настройки кассиров доступны по праву просмотра кассиров." /> : children}</ReceiptsServiceScreen>
}
